import { create } from "zustand";


interface PremiumStoreProps {
    premium: any;
    setPremium: (payload: any) => void;
}

export const premiumStore = create<PremiumStoreProps>((set, get, api) => ({
    premium: null,
    setPremium: (payload) => set(() => ({
        premium: payload
    })),
}));
